import { supabase } from "@/integrations/supabase/client";

/**
 * Gets or creates a 1:1 conversation between the current user and a friend.
 * Uses a SECURITY DEFINER RPC that verifies friendship server-side and inserts
 * both participant rows atomically (avoiding RLS issues with adding the friend).
 * Returns the conversation ID.
 */
export async function getOrCreateConversation(friendId: string): Promise<string> {
  const { data, error } = await supabase.rpc("get_or_create_conversation", {
    friend_id: friendId,
  });
  if (error) throw error;
  if (!data) throw new Error("Could not create conversation");
  return data as string;
}
